// Angular
import { Injectable } from "@angular/core";
// Services
import { ApiService } from "./../api";
import { ElasticService } from "./../elastic";
import { OAuthService } from "./../o-auth";
// External
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class AuthGuardService {
  constructor(
    private apiService: ApiService,
    private elasticService: ElasticService,
    private oAuthService: OAuthService,
    private fireAuth: AngularFireAuth,
    private fireDatabase: AngularFireDatabase

  ) { }

  canActivate(): Promise<boolean> {
    return new Promise(resolve => {
      const fireAuthSubscription = this.fireAuth.authState.subscribe(user => {
        fireAuthSubscription.unsubscribe();

        console.log(user)
        if (!user) {
          this.oAuthService.logout();
          return resolve(false);
        }

        this.fireDatabase.object(`/users/${user.uid}`).subscribe(club => {
          if (club.type) {
            if (club.type != 1) {
              alert("User is not a club");
              this.oAuthService.logout();
              return resolve(false);
            }
          }


          const queryParams = {
            index: "users",
            type: "club",
            "body/query/bool/must/query_string/query": club.$key,
            "body/query/bool/must/query_string/fields": ["uid^10"]
          };

          this.elasticService
            .search(queryParams)
            .then(clubs => {
              let currentClub;

              if (clubs["hits"].length) {
                currentClub = clubs["hits"][0]["_source"];
                currentClub["$key"] = clubs["hits"][0]["_id"];
              }

              if (!currentClub || currentClub["uid"] !== club.$key) {
                alert("User is not a club");
                this.oAuthService.logout();
                return resolve(false);
              }
              if (!currentClub["isVerified"]) {
                alert("Account not accepted");
                this.oAuthService.logout();
                return resolve(false);
              }
              this.fireDatabase.object("users/" + currentClub.$key).subscribe((res) => {
                console.log(res)

                this.oAuthService
                  .setClub(res)
              })
              this.oAuthService
                .setClub(currentClub)
                .then(() => {
                  return resolve(true);
                })
                .catch(error => {
                  console.error(error);

                  this.oAuthService.logout();
                  return resolve(false);
                });
            })
            .catch(error => {
              console.error(error);

              this.oAuthService.logout();
              return resolve(false);
            });
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/services/auth-guard/auth-guard.service.ts